import { create } from 'zustand'

type MembershipDialogState = {
  open: boolean
  openDialog: () => void
  closeDialog: () => void
}

export const useMembershipDialogStore = create<MembershipDialogState>((set) => ({
  open: false,
  openDialog: () => set({ open: true }),
  closeDialog: () => set({ open: false }),
}))